export default "__VITE_ASSET__7fed827c__"